import React from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import "./Docs.css";

const Docs = () => {
  const docSections = [
    { icon: "fa-rocket", title: "Getting Started", desc: "Quick setup guide to get Contextly AI running in under 5 minutes.", link: "#" },
    { icon: "fa-book", title: "API Reference", desc: "Complete REST API documentation with request/response examples.", link: "#" },
    { icon: "fa-puzzle-piece", title: "Integrations", desc: "Connect with Google Drive, Notion, Slack, and more.", link: "#" },
    { icon: "fa-code", title: "SDKs & Libraries", desc: "Official SDKs for Python, Node.js, Go, and REST clients.", link: "#" },
    { icon: "fa-shield-alt", title: "Security & Compliance", desc: "SOC-2, GDPR, HIPAA compliance details and architecture.", link: "#" },
    { icon: "fa-question-circle", title: "FAQ & Troubleshooting", desc: "Common questions, error codes, and debugging guides.", link: "#" },
  ];

  return (
    <div className="docs-page">
      <section className="docs-hero">
        <div className="docs-badge"><span className="badge-dot"></span> Documentation</div>
        <h1>Everything you need to<br /><span className="gradient-text">build with Contextly</span></h1>
        <p>Comprehensive guides, API references, and examples to integrate and customize your Contextly AI setup.</p>
        <div className="docs-search">
          <i className="fa fa-search"></i>
          <input type="text" placeholder="Search documentation..." />
        </div>
      </section>

      <section className="docs-grid-section">
        <div className="docs-grid">
          {docSections.map((doc, i) => (
            <Link key={i} to={doc.link} className="doc-card">
              <div className="doc-icon"><i className={`fa ${doc.icon}`}></i></div>
              <h3>{doc.title}</h3>
              <p>{doc.desc}</p>
              <span className="doc-link">Read more <i className="fa fa-arrow-right"></i></span>
            </Link>
          ))}
        </div>
      </section>

      <section className="docs-cta">
        <h2>Can't find what you're looking for?</h2>
        <p>Our team is here to help. Reach out through our community or contact support.</p>
        <div className="docs-cta-buttons">
          <Link to="/" className="btn-primary">Join Community <i className="fa fa-comments"></i></Link>
          <Link to="/" className="btn-secondary"><i className="fa fa-envelope"></i> Contact Support</Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Docs;
